import Box from "@mui/material/Box";
import clsx from "clsx";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Link } from "@mui/material";
import ThumbDown from "../../../../../../../assets/images/icons/ThumbDown";
import ThumbUp from "../../../../../../../assets/images/icons/ThumbUp";
import BriaTooltip from "../../../../../../../components/common/BriaTooltip/BriaTooltip";
import { TG_FEEDBACKS_TO_EVOLVE } from "../../../../../../../constants/TgConstants";
import EvolveModelPopup from "../../../../../Models/Popups/EvolveModelPopup/EvolveModelPopup";
import { TgModel } from "../../../../../Models/store/tg-model-store";
import styles from "./TgModelFeedbackCount.module.scss";

const TgModelFeedbackCount = ({ model }: { model: TgModel }) => {
	const { t } = useTranslation("tg", { keyPrefix: "models.dashboard.table.feedback_count" });
	const [openEvolvePopup, setOpenEvolvePopup] = useState(false);
	const isEvolveEnabled = model.feedback_count.positive >= TG_FEEDBACKS_TO_EVOLVE;

	const handleOpenEvolvePopup = () => {
		if (isEvolveEnabled) {
			setOpenEvolvePopup(true);
		}
	};

	return (
		<>
			<Box className={styles.feedbackCountCell}>
				<Box className={styles.countRow}>
					<BriaTooltip title={t("positive")}>
						<Box className={styles.countItem}>
							<ThumbUp />
							<p>{model.feedback_count.positive}</p>
						</Box>
					</BriaTooltip>
					<BriaTooltip title={t("negative")}>
						<Box className={styles.countItem}>
							<ThumbDown />
							<p>{model.feedback_count.negative}</p>
						</Box>
					</BriaTooltip>
				</Box>
				<BriaTooltip title={isEvolveEnabled ? t("enabledEvolveTooltip") : t("disabledEvolveTooltip")}>
					<Link
						className={clsx(styles.evolveLink, { [styles.disabled]: !isEvolveEnabled })}
						onClick={handleOpenEvolvePopup}
					>
						{t("evolveModel")}
					</Link>
				</BriaTooltip>
			</Box>
			<EvolveModelPopup open={openEvolvePopup} onClose={() => setOpenEvolvePopup(false)} model={model} />
		</>
	);
};

export default TgModelFeedbackCount;
